export default __webpack_public_path__ + "static/media/list.410531ca.svg";